<template>
  <router-view />
</template>

<script setup>
// Raíz de la SPA. El layout se aplica por ruta (AppLayout para las rutas privadas).
</script>
